module.exports = __webpack_public_path__ + "static/media/deccom.fc68476d.webp";